import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const DashboardFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the DashboardFrame component. Replace this with your actual
          UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default DashboardFrame;
